import type { CampaignFormData } from '@/components/CreateCampaignDialog/createCampaignType'
import { useState } from 'react'

export const useMultiStepForm = (totalSteps: number) => {
  const [currentStep, setCurrentStep] = useState(1)
  const [formData, setFormData] = useState<Partial<CampaignFormData>>({})
  const [errors, setErrors] = useState<Record<string, string>>({})

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep((prev) => prev + 1)
    }
  }

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1)
    }
  }

  const goToStep = (step: number) => {
    if (step >= 1 && step <= totalSteps) {
      setCurrentStep(step)
    }
  }

  const updateData = (data: Partial<CampaignFormData>) => {
    setFormData((prev) => ({ ...prev, ...data }))
    setErrors((prev) => {
      const newErrors = { ...prev }
      for (const key of Object.keys(data)) {
        delete newErrors[key]

        // clear nested errors (for budget)
        const value = data[key as keyof CampaignFormData]
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          for (const nestedKey of Object.keys(value as object)) {
            delete newErrors[nestedKey]
          }
        }
      }
      return newErrors
    })
  }

  const updateErrors = (newErrors: Record<string, string>) => {
    setErrors(newErrors)
  }

  const resetForm = () => {
    setCurrentStep(1)
    setFormData({})
    setErrors({})
  }

  return {
    currentStep,
    formData,
    errors,
    nextStep,
    prevStep,
    goToStep,
    updateData,
    updateErrors,
    resetForm,
  }
}
